import { GeneralCellContent } from 'shared/types/models/Server';

export function isEmptyCellContent(value: GeneralCellContent) {
  return value === null || value === '';
}
